import classNames from 'classnames'
import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Button, Icon } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import styles from './HeaderLink.module.css'

export interface HeaderLinkProps {
  to: string
  children: React.ReactNode
  className?: string
  replace?: boolean
}

export const HeaderLink: React.FC<HeaderLinkProps> = ({
  to,
  children,
  className,
  replace = false,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation(['common'])

  return (
    <>
      <div className={styles.mobileWrapper}>
        <Link
          to={to}
          className={classNames(
            styles.mobileLink,
            'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2'
          )}
          aria-label={t('common:backToHome')}
        >
          <Icon icon="arrow-left" className="mr-4 fill-current w-4" />
          {children}
        </Link>
      </div>

      <Button
        onClick={() => navigate(to, { replace })}
        variant="pill"
        icon="angle-left"
        aria-label={t('common:backToHome')}
        className={classNames(
          'hidden min-tablet:inline-flex items-center mt-6 mb-3',
          styles.desktopButton,
          className
        )}
      >
        {children}
      </Button>
    </>
  )
}
